/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultBasedAverage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_009: Question = {
  id: 'gov-009-montant-fonds',
  oldId: '9',
  title: 'Montant contribué à un fond',
  number: '1.9',
  type: QuestionType.INDICATOR,
  frequency: 1,
  description: [],
  slots: [
    {
      type: SlotTypes.REPEATER,
      data: ['0'],
      items: [''],
      repeaterFields: [
        {
          label: 'Nom du Fonds',
          slug: 'fonds',
          width: '45%',
        },
        {
          label: 'Montant alloué',
          slug: 'amount',
          width: '35%',
          type: 'number',
        },
        {
          label: 'Année',
          slug: 'year',
          width: '20%',
        },
      ],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 100) return 4;
        if (data >= 75) return 3;
        if (data >= 50) return 2;
        if (data >= 25) return 1;
        return 0;
      },
      score: '0',
      maxScore: 4,
      help: defaultBasedAverage,
      unit: SlotUnit.DOLLAR_PER_RESIDENT,
    },
  ],
};

export const question_gov_009_v2: Question = question_gov_009;
export const question_gov_009_v3: Question = question_gov_009;
